// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Hp9P","label":"CategoryService_label__3D03u","location":"CategoryService_location__1Sch-"};